module.exports = __webpack_public_path__ + "static/media/maintenance.b89802ff.png";